module.exports = __webpack_public_path__ + "img/933cbe1.jpg";